/**
 * Build a full S3 URL from a relative path.
 * @param {string} relativePath - e.g. "/bucket/img.jpg" or "bucket/img.jpg"
 * @returns {string} Full URL or ""
 */
function buildS3Url(relativePath) {
  if (!relativePath) return "";

  const s3Path = relativePath.startsWith("/")
    ? relativePath.substring(1)
    : relativePath;

  const baseUrl = global.config?.images3?.link;
  if (!baseUrl) return "";

  return baseUrl.endsWith("/")
    ? `${baseUrl}${s3Path}`
    : `${baseUrl}/${s3Path}`;
}

/**
 * Get full-resolution image URL.
 * Prefers S3OriginalRelativePath (original upload), falls back to S3RelativePath.
 * Used by Compare modal canvas and ZoomModal for high-res viewing.
 *
 * @param {Object} imageObj - Image object from API
 * @returns {string} Full image URL or ""
 */
export function getFullImageUrl(imageObj) {
  if (!imageObj) return "";

  // check if imageObj contain key S3OriginalRelativePath and it is not empty
  try {
    if (imageObj.S3OriginalRelativePath) {
      return buildS3Url(imageObj.S3OriginalRelativePath);
    }
  }
  catch {
    return buildS3Url(imageObj.S3RelativePath);
  }

  // return buildS3Url(imageObj.S3OriginalRelativePath) || buildS3Url(imageObj.S3RelativePath);

  return buildS3Url(imageObj.S3RelativePath);
}

/**
 * Get thumbnail/display image URL.
 * Uses S3RelativePath (processed/compressed version).
 * Used by MultipleImages thumbnails, GalleryCard preview, Compare thumbnails.
 *
 * @param {Object} imageObj - Image object from API
 * @returns {string} Thumbnail URL or ""
 */
export function getThumbnailUrl(imageObj) {
  if (!imageObj) return "";
  return buildS3Url(imageObj.S3RelativePath);
}
